module.exports = __webpack_public_path__ + "img/brochure.869a537.svg";